module.exports = __webpack_public_path__ + "static/media/05.Yaksha gana-ink.62bd74e8.jpeg";